import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { connect } from 'react-redux';
import { getReportData } from '../../actions/dashboard';

import Loading from '../common/Loading';
import NewJourneyView from './NewJourneyView'; // Import the new component

const CsvChartModal = ({
  isOpen,
  onClose,
  getReportData,
  reportData,
  isLoading,
  error,
  business,
  auth,
  selectedDateRange,
  selectedUserType,
}) => {
  useEffect(() => {
    if (isOpen) {
      const { selectedLocation } = business;
      const id = selectedLocation.studioId || auth.studio_id;
      getReportData({
        business_id: id,
        selectedDateRange,
        selectedUserType,
      });
    }
  }, [isOpen, getReportData, business, auth, selectedDateRange, selectedUserType]);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="CSV Chart Modal"
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.75)',
          zIndex: 1000,
        },
        content: {
          top: '50%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          width: '90%',
          height: '90%',
          padding: '0',
          overflow: 'hidden'
        }
      }}
    >
      <button
        onClick={onClose}
        style={{
          position: 'absolute',
          top: '15px',
          right: '15px',
          background: '#fff',
          border: '1px solid #ddd',
          borderRadius: '50%',
          width: '40px',
          height: '40px',
          fontSize: '24px',
          lineHeight: '38px',
          textAlign: 'center',
          cursor: 'pointer',
          zIndex: 10,
          color: '#555',
          boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
          transition: 'all 0.2s ease-in-out',
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.transform = 'scale(1.1)';
          e.currentTarget.style.boxShadow = '0 4px 10px rgba(0,0,0,0.2)';
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.transform = 'scale(1)';
          e.currentTarget.style.boxShadow = '0 2px 5px rgba(0,0,0,0.1)';
        }}
      >
        &times;
      </button>
      <div style={{ height: '100%', overflowY: 'auto' }}>
        {isLoading ? (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <Loading />
          </div>
        ) : error ? (
          <div style={{ color: 'red', padding: '20px' }}>Error: {error}</div>
        ) : (
          <NewJourneyView csvData={reportData} business={business} auth={auth} />
        )}
      </div>
    </Modal>
  );
};

CsvChartModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  getReportData: PropTypes.func.isRequired,
  reportData: PropTypes.string,
  isLoading: PropTypes.bool,
  error: PropTypes.string,
  business: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  selectedDateRange: PropTypes.string,
  selectedUserType: PropTypes.string,
};

const mapStateToProps = (state) => ({
  reportData: state.dashboard.reportData,
  isLoading: state.dashboard.isLoading,
  error: state.dashboard.error,
  business: state.business,
  auth: state.auth,
});

export default connect(mapStateToProps, { getReportData })(CsvChartModal);
